import React from "react";
import "./style.css";
import MainHeading from "../Utils/mainHeading";
import PrimeryButton from "../../ControlledComponents/PrimeryButton/PrimeryButton";
import { useNavigate } from "react-router-dom";
import Button4 from "../../GlobalComponents/button3";
import { MdOutlineReadMore } from "react-icons/md";
import { MdReadMore } from "react-icons/md";
import { AiFillFire } from "react-icons/ai";
import { useTranslation } from "react-i18next";

export default function ReadyToAsk() {
    const { t ,i18n} = useTranslation();
    const navigate = useNavigate();
    const navigateToContactPage = () => {
        navigate(`/contact-us`)
    }
    const fullTitle = t("workus.title"); // "Ready to work with us?"
const titleParts = fullTitle.split(" ");
const content1 = titleParts.slice(0, 3).join(" "); // "Ready to work"
const content2 = titleParts.slice(3).join(" "); 
    return(
        <div className="readyToAsk">
            <MainHeading width={'95%'} gap={'10px'} flexDirection={'row'} margin={"0"} content1={content1}
  content2={content2} />
            {/* <PrimeryButton 
                text={'Get Started Today'} 
                width={'280px'} 
                height={'55px'}
                fontSize={'18px'}
                lineHeight={'22px'}
                fontWeight={'400'}
                color={'#fff'}
                arrowTrue={true}
                navigateClick={navigateToContactPage}
            /> */}
              <Button4 
            text_1={t("workus.getstaretd") }
            
            text_2={t("workus.getstaretd")}
            iconComponent={AiFillFire} 
            width={"220px"}   
            navigateClick={()=>{
                    navigate("/contact-us")
                }} />
        </div>
    )
}
